import { render, staticRenderFns } from "./editProjectView.vue?vue&type=template&id=70f5e340&"
import script from "./editProjectView.vue?vue&type=script&lang=js&"
export * from "./editProjectView.vue?vue&type=script&lang=js&"
import style0 from "./editProjectView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports